import { Injectable } from '@angular/core';
import { AreaItemPack } from '../models/area-item-pack';
import { Observable, of } from 'rxjs';
import { AreaItem } from '../models/area-item';
import { TimeRestriction } from '../models/time-restriction';
import { Product } from '../../order/models/product';
import { BookingSlot } from '../models/booking-slot';
import { ShopSettings } from '../models/shop-settings';
import { GroupEventOrder } from '../../order/models/group-event-order';
import { ContactField } from '../../contact/models/contact-field';
import { EventAreaItemSlot } from '../models/event-area-item-slot';


@Injectable()
export class BookingService {
  constructor() { }

  getAreaItems(areaItemPackId: number): Observable<AreaItem[]> {
    return of();
  }

  getAllAreaItems(): Observable<AreaItem[]> {
    return of();
  }

  getAreaItemPacks(): Observable<AreaItemPack[]> {
    return of();
  }

  getAreaRestrictions(areaItemPackId: number): Observable<TimeRestriction[]> {
    return of();
  }

  getBookingSlots(areaItemPackId: number, date: Date): Observable<BookingSlot[]> {
    return of();
  }

  getEventBookingSlots(areaItem: AreaItem, date: Date): Observable<BookingSlot[]> {
    return of();
  }

  sendGroupEventOrder(groupEventOrder: GroupEventOrder): Observable<boolean> {
    return of();
  }

  sendContactForm(contactField: ContactField): Observable<boolean> {
    return of();
  }

  getEventAreaItemSlots(): Observable<EventAreaItemSlot[]> {
    return of();
  }

  getAvailableTicketQuantity(): Observable<number> {
    return of(-1);
  }
}
